import { Link } from "@tanstack/react-router";

// The one "Merchant" cell every list page renders: business name on top,
// public ID underneath (muted), the whole cell clickable through to that
// merchant's detail page. `-m-2 block p-2` negates DataTable's own cell
// padding so the link fills the entire cell — same convention the file-local
// RowLink helpers (_app.merchants.tsx, _app.invoices.tsx, _app.tariffs.tsx)
// already used for their own single-line links.
//
// Always navigates to the merchant page, even on rows whose other cells open
// a detail dialog for that row's own entity (AML case, webhook delivery) —
// a deliberate, consistent exception: Merchant is the one column about a
// different entity than the row itself.

export interface MerchantCellProps {
  merchantId: string;
  businessName: string;
  publicId: string;
}

export function MerchantCell({ merchantId, businessName, publicId }: MerchantCellProps) {
  return (
    <Link
      to="/merchants/$merchantId"
      params={{ merchantId }}
      className="group -m-2 block p-2"
      onClick={(e) => e.stopPropagation()}
    >
      <span className="block truncate text-foreground group-hover:underline" title={businessName}>
        {businessName}
      </span>
      <span className="block text-xs text-muted-foreground">{publicId}</span>
    </Link>
  );
}
